import { useEffect } from 'react';

import { Button } from '@mui/material';
import Container from '@mui/material/Container';

import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';

import { getPackagingItemById } from 'src/redux/slices/packaging-item';

import ErrorContent from 'src/components/error-content';
import { useSettingsContext } from 'src/components/settings';
import { LeftIcon } from 'src/components/carousel/arrow-icons';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';

import { LoadingScreen } from '../../../components/loading-screen';
import PackagingItemNewEditForm from '../packaging-item-new-edit-form';
import { useAppDispatcher, useAppSelector } from '../../../redux/store';

type Props = {
  id: string;
};

export default function PackagingItemEditView({ id }: Props) {
  const { item, status, error } = useAppSelector((state) => state.packagingItem);

  const settings = useSettingsContext();
  const dispatch = useAppDispatcher();

  useEffect(() => {
    dispatch(getPackagingItemById({ itemID: id }));
  }, [dispatch, id]);

  if (status === 'loading' || status === 'idle') {
    return <LoadingScreen />;
  }

  if (status === 'failure') {
    return (
      <ErrorContent
        filled
        title="Failed to load packaging item details"
        description={error}
        action={
          <Button
            component={RouterLink}
            href={paths.dashboard.packagingItem.root}
            variant="contained"
            startIcon={<LeftIcon />}
          >
            Back to Packaging Items
          </Button>
        }
        sx={{
          py: 10,
        }}
      />
    );
  }

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <CustomBreadcrumbs
        heading="Edit packaging item"
        links={[
          {
            name: 'Packaging Items',
            href: paths.dashboard.packagingItem.root,
          },
          { name: 'Edit packaging item' },
        ]}
        sx={{
          mb: { xs: 3, md: 5 },
        }}
      />

      <PackagingItemNewEditForm currentPackagingItem={item} />
    </Container>
  );
}
